import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const Summary = (props) => (
  <div>
    <p>Summary Component</p>
    <Text field={props.fields.heading} />
  </div>
);

export default Summary;
